// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class PFixHistoryResponseMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_PFIX_HISTORY_RESP, fieldSet);
    }
    GetIsHistoryLimitReached() {
        const fs = this.FieldSet;
        return fs.GetValue(FieldsFactory.FIELD_QUOTE_HISTORY_LIMIT_REACHED) || false;
    }
}
